var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-circle",
    clipPath: "url(#clip0_1449_20725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.49972 6.18807V8.83093M8.49972 11.4738H8.50633M15.1069 8.83093C15.1069 12.48 12.1487 15.4381 8.49972 15.4381C4.8507 15.4381 1.89258 12.48 1.89258 8.83093C1.89258 5.1819 4.8507 2.22379 8.49972 2.22379C12.1487 2.22379 15.1069 5.1819 15.1069 8.83093Z",
    stroke: "#D92D20",
    strokeWidth: 1.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_20725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8571,
    height: 15.8571,
    fill: "white",
    transform: "translate(0.571289 0.902344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.7bc06956df494e254ebffb0cf336d4eb.svg";
export { ForwardRef as ReactComponent };